"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var netinfo_1 = require("@wora/netinfo");
function useNetInfo(configuration) {
    var _a = react_1.useState({
        type: 'unknown',
        isInternetReachable: false,
        isConnected: false,
        details: null,
    }), netInfo = _a[0], setNetInfo = _a[1];
    react_1.useEffect(function () {
        netinfo_1.NetInfo.fetch().then(setNetInfo);
        return netinfo_1.NetInfo.addEventListener(setNetInfo);
    }, []);
    return netInfo;
}
exports.useNetInfo = useNetInfo;
//# sourceMappingURL=useNetInfo.js.map